<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2">CHAPTER 2</h2>
<hr class="hr"/>
<h2 class="h2title">ANTS</h2>
<p class="noindent"><span class="stickup">T</span>he skinniest of the boys was named Quenton Cassidy. The year before, in the first grade, he had marched up to his gangly bespectacled best friend Stiggs at recess and announced: “I’m the fastest kid in first grade.”</p>
<p class="indent">“No, you aren’t,” Stiggs said. “<span class="txit">He</span> is.”</p>
<p class="indent">He was pointing to Demski, a spindly creature with an oblong skull and a crew cut so severe as to make his hair invisible. He was squatting in the roots of a huge live oak next to the jungle bars, enthralled by a very active colony of red ants. Demski lived on Homer Circle two blocks from Cassidy, and because his mom wouldn’t let him play pickup football, no one had paid him much attention. When they marched over, Demski didn’t look up.</p>
<p class="indent">“Whatcha doin’, looking at ants?” Cassidy said.</p>
<p class="indent">Demski nodded.</p>
<p class="indent">“What are they up to?” Stiggs said.</p>
<p class="indent">Demski shrugged. “Buh-buh-buh-building stuff, I guess.”</p>
<p class="indent">Cassidy and Stiggs leaned over to get a better look.</p>
<p class="indent">“There sure are a lot of them,” Cassidy said.</p>
<p class="indent">Demski nodded.</p>
<p class="indent">“He wants to race you,” Stiggs said. “He says he’s the fastest kid in first grade.”</p>
<p class="indent">“Okay,” said Demski without enthusiasm.</p>
<p class="indent">Several other kids had gathered around because three people watching ants apparently constituted some kind of quorum.</p>
<p class="indent">“Race, race!” they chanted.</p>
<p class="indent">“Monkey bars to home plate on the first diamond,” said Stiggs, assuming authority as usual. “I say, ‘Ready, set, go,’ and you take off. Randleman, you go stand at home in case it’s close, which it won’t be.”</p>
<p class="indent">Randleman, a sturdy, good-natured kid, loped off.</p>
<p class="indent">“Ready. Set. Go!” said Stiggs. Demski took off, but Cassidy was holding his hand up.</p>
<p class="indent">“Time out!” he said. “Kings X! I need to take my shoes off. I have to run barefoot.” Demski circled back, eyeing Cassidy dispassionately as he removed his Thom McAns and the ridiculous argyle socks his mother made him wear because they were a Christmas present from his great-aunt Mary and she had diabetes.</p>
<p class="indent">“All right, dammit,” said Stiggs, who was just learning to cuss. “Take your damn shoes off. Anything else you need? Want to change your clothes or have a little snack?” The small crowd laughed. Stiggs, everyone agreed, was the wittiest kid in first grade.</p>
<p class="indent">When Cassidy was finally ready and he and Demski were crouched side by side, Stiggs held his arm in the air dramatically.</p>
<p class="indent">“Ready. Set. <span class="txit">Go</span><span class="txit">!</span>” Apropos of nothing, he added another “Dammit.”</p>
<p class="indent">Ed Demski really was the fastest kid in first grade, so it wasn’t much of a contest, though Cassidy surprised everyone by making it close.</p>
<p class="indent">Stiggs was standing by the monkey bars, arms folded smugly across his chest, as Cassidy came back to get his shoes and socks, still panting.</p>
<p class="indent">“What do you say now, big mouth?” Stiggs said as the bell rang.</p>
<p class="indent">Cassidy sat on the ground with spindly legs crossed, vigorously shaking sand out of a shoe. He looked up at Stiggs and brightened.</p>
<p class="indent">“Hey, Stiggs,” he said, “guess what? I’m the second-fastest kid in first grade!”</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch02.vue?29d4338c